import React from "react";

import { useRetrieveProjectExternalLinks } from "@planzone/view-models";
import { projectExternalLink } from "@planzone/dto";
import { UseCases } from "@planzone/core";
import { Safeguard } from "@scenes/safeguard";
import { useModal } from "@root/client/modal";
import { Props } from "./types";
import { Link } from "./link";
import { AddLinkIcon } from "./addLinkIcon";
import { LinkMenu } from "./linkMenu";
import styles from "./styles.scss";

function ExternalLinksList({ project }: Props) {
  const {
    isRequestFailure,
    isRequestSuccess,
    isRequestPending,
    links,
    retrieveProjectExternalLinks,
  } = useRetrieveProjectExternalLinks(project);
  const { pushView } = useModal();

  React.useEffect(() => {
    !!project.uuid &&
      !isRequestPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrieveProjectExternalLinks(project);
  }, [project.uuid]);

  return (
    <ul className={styles.externalLinksList}>
      {new Array(4)
        .fill({ ...projectExternalLink, index: -1 })
        .map((placeholder, index) => {
          const link = links.find((l) => l.index === index);

          return (
            <Safeguard
              useCases={[
                UseCases.addProjectExternalLink,
                UseCases.removeProjectExternalLink,
              ]}
            >
              {({ canAddProjectExternalLink, canRemoveProjectExternalLink }) =>
                link ? (
                  <li key={index} className={styles.item}>
                    <Link link={link} />
                    {(canAddProjectExternalLink ||
                      canRemoveProjectExternalLink) && (
                      <div className={styles.linkMenu}>
                        <LinkMenu link={link} project={project} />
                      </div>
                    )}
                  </li>
                ) : (
                  <li
                    key={index}
                    className={styles.item}
                    onClick={() =>
                      canAddProjectExternalLink &&
                      pushView({
                        data: project,
                        key: UseCases.addProjectExternalLink,
                      })
                    }
                  >
                    <AddLinkIcon
                      className={styles.addLinkIcon}
                      isEditable={canAddProjectExternalLink}
                    />
                  </li>
                )
              }
            </Safeguard>
          );
        })}
    </ul>
  );
}

export { ExternalLinksList };
